import styled from "styled-components";

import CloseIcon from "../../plugins/unt/assets/images/close-icon.svg";

const PluginCloseButton = styled.button.attrs({
  className: "closeButton absolute right-1 top-0 ma2 pointer tc bn z-1",
})`
  background-image: url(${CloseIcon});
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0;
  width: 32px;
  height: 32px;
  background-color: transparent;
`;

export default PluginCloseButton;
